import { render, staticRenderFns } from "./HtmlTextComponent.vue?vue&type=template&id=61914c4c&scoped=true&"
import script from "./HtmlTextComponent.vue?vue&type=script&lang=js&"
export * from "./HtmlTextComponent.vue?vue&type=script&lang=js&"
import style0 from "./HtmlTextComponent.vue?vue&type=style&index=0&id=61914c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61914c4c",
  null
  
)

export default component.exports